
window._             = require('lodash');
window.Popper        = require('popper.js').default;
window.toastr        = require('toastr');
window.axios         = require('axios');
window.Dropzone      = require('dropzone');
window.Inputmask     = require('inputmask');
window.typehead      = require('typeahead.js');
window.Bloodhound    = require('typeahead.js/dist/bloodhound');
window.Handlebars    = require('handlebars');
window.printJs    = require('print-js');

// loosely coupled libraries
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

// Load jQuery and dependent libs
try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('@coreui/coreui');
    require('icheck');
    require('bootstrap-datepicker');
    require('bootstrap-datepicker/js/locales/bootstrap-datepicker.pl');
    require('summernote/src/js/summernote');
    require('summernote/src/js/bs4/settings');
} catch (e) {
    console.log(e);
}

// Configure CSRF token for axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found!');
}



// WEBPACK FOOTER //
// ./resources/js/bootstrap.js